"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var basics_1 = require("@syl-editor/core-utilities/dist/lib/schema/basics");
var parse_1 = require("@syl-editor/core-utilities/dist/lib/libs/parse");
var typeset_1 = require("../utils/typeset");
var tools_1 = require("../utils/tools");
var Paragraph = /** @class */ (function (_super) {
    __extends(Paragraph, _super);
    function Paragraph(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.props = {};
        // * 因为可以从外部传入默认配置（不渲染），此处作为默认toDOMAttrs
        _this.toDOMAttrs = {};
        _this.formatAttrs = function (attrs) { return attrs; };
        _this.constructParseDOM = function (config) {
            var parseRule = _this.parseDOM[0];
            var _a = typeset_1.constructTypesetParseDOM(config), defaultFontSize = _a.defaultFontSize, formatAttrs = _a.formatAttrs, defaultAttrs = _a.defaultAttrs;
            _this.formatAttrs = formatAttrs;
            _this.toDOMAttrs = __assign(__assign({}, _this.attrs), defaultAttrs);
            // TODO 其他非内置组件处理
            var hasInlineImage = false;
            setTimeout(function () { var _a; return (hasInlineImage = (_a = _this.editor.view.state.schema.nodes.image) === null || _a === void 0 ? void 0 : _a.isInline); });
            parseRule.canMatch =
                config.canMatch || (function (dom) { return (hasInlineImage ? true : !/<img/.test(dom.innerHTML)); });
            parseRule.defaultFontSize = defaultFontSize;
            parseRule.formatAttrs = function (attrs, dom) {
                var formattedAttrs = formatAttrs(attrs);
                tools_1.getFromDOMByConfig(_this.props.addAttributes, dom, formattedAttrs);
                return formattedAttrs;
            };
            if (config.addMatchTags) {
                config.addMatchTags.forEach(function (tagName) { return _this.parseDOM.push(__assign(__assign({}, parseRule), { tag: tagName })); });
            }
        };
        _this.toDOM = function (node) {
            var attrs = {};
            var addAttributes = _this.props.addAttributes;
            var style = parse_1.getTypesetDOMStyle(node.attrs, _this.toDOMAttrs);
            if (style)
                attrs.style = style;
            var extraAttrs = {};
            if (node.attrs.class) {
                extraAttrs.class = node.attrs.class;
                _this.formatAttrs(extraAttrs);
            }
            tools_1.setDOMAttrByConfig(addAttributes, node, Object.assign(attrs, extraAttrs));
            return ['p', attrs, 0];
        };
        _this.editor = editor;
        if (props) {
            _this.constructParseDOM(props);
            _this.props = props;
            tools_1.addAttrsByConfig(_this.props.addAttributes, _this.attrs);
            _this.constructParseDOM(_this.props);
        }
        return _this;
    }
    return Paragraph;
}(basics_1.Paragraph));
exports.Paragraph = Paragraph;
var ParagraphPlugin = /** @class */ (function (_super) {
    __extends(ParagraphPlugin, _super);
    function ParagraphPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'paragraph';
        _this.Schema = Paragraph;
        return _this;
    }
    return ParagraphPlugin;
}(core_utilities_1.SylPlugin));
exports.ParagraphPlugin = ParagraphPlugin;
//# sourceMappingURL=paragraph.js.map